const messages = {
    en: {
        delivery: {
            cashRegister: {
                name: 'Cash Register',
                title: 'Cash Register management',
                subtitle: 'View, search, create, edit and delete cash registers',
                creating: 'Creating Cash Register',
                editing: 'Editing Cash Register',
                deleting: 'Deleting Cash Register',
                showing: 'Cash Register details',
                menu: 'Cash Registers',
                yes: 'Yes',
                no: 'No',
                labels: {
                    name: 'Name',
                    user: 'User',
                    email: 'Email',
                    role: 'Role',
                    active: 'Active'
                },
                actions: {
                    addUser: 'Add user'
                },
                validations: {
                    activeUsers: 'Select only active users'
                }
            }
        }
    },
    es: {
        delivery: {
            cashRegister: {
                name: 'Caja',
                title: 'Administración de Cajas',
                subtitle: 'Ver, buscar, crear, editar y borrar cajas',
                creating: 'Creando Caja',
                editing: 'Modificando Caja',
                deleting: 'Eliminando Caja',
                showing: 'Detalles de Caja',
                menu: 'Cajas',
                yes: 'Sí',
                no: 'No',
                labels: {
                    name: 'Nombre Caja',
                    user: 'Usuario',
                    email: 'Email',
                    role: 'Rol',
                    active: 'Activo'
                },
                actions: {
                    addUser: 'Agregar usuario'
                },
                validations: {
                    activeUsers: 'Seleccione solo usuarios activos'
                }
            }
        }
    },
    pt: {
        delivery: {
            cashRegister: {
                name: 'Caixa',
                title: 'Administração de Caixas',
                subtitle: 'Ver, buscar, criar, editar e apagar caixas',
                creating: 'Criando Caixa',
                editing: 'Editando Caixa',
                deleting: 'Apagando Caixa',
                showing: 'Detalhes da Caixa',
                menu: 'Caixas',
                yes: 'Sim',
                no: 'Não',
                labels: {
                    name: 'Nome Caixa',
                    user: 'Usuário',
                    email: 'Email',
                    role: 'Perfil',
                    active: 'Ativo'
                },
                actions: {
                    addUser: 'Adicionar usuário'
                },
                validations: {
                    activeUsers: 'Selecione apenas usuários ativos'
                }
            }
        }
    }
}

export default messages
